export enum DATA_QA {
  ROOT = 'delete-campaign',
  CANCEL = 'delete-campaign__cancel',
  CONFIRM = 'delete-campaign__confirm',
}
